import { type ComponentPropsWithoutRef, forwardRef, type ReactNode } from 'react'

interface ProductTagProps extends ComponentPropsWithoutRef<'span'> {
  label: string
  icon?: ReactNode
}

// The grey tag beside a title on every onboarding surface. Forwards ref and props
// so it can be a Radix `asChild` tooltip trigger.
export const ProductTag = forwardRef<HTMLSpanElement, ProductTagProps>(
  ({ label, icon, ...props }, ref) => (
    <span
      ref={ref}
      {...props}
      className="inline-flex h-5 shrink-0 items-center gap-1 rounded border border-st2 bg-background px-2 font-jetbrains text-label uppercase text-muted-foreground"
    >
      {icon}
      {label}
    </span>
  ),
)
ProductTag.displayName = 'ProductTag'
